import React from 'react'
import { connect } from 'react-redux'
import { AvailableActions } from '../../redux/actions/dataQuery'

import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import Tooltip from 'antd/lib/tooltip'
import debounce from 'lodash.debounce'

import HelpPopovers from './HelpPopovers.jsx'
import parseCoordinates from '../../modules/parseValidateCsv'
import s from './style.scss'

/*
    @todo: let user select delimiter, so he can use space again, which is not auto-detected
    @todo: maybe replace swap lat/lon with checkbox
    @todo: maybe add map
    @todo: maybe let user specify order of input values
    @todo: run parsing and validating in web worker for better performance
    @todo: when there is a lot of input in the textarea typing and moving
        the cursor is slow. theory: the browser renders the whole textarea
        instead of just the visible part, because of display: scroll. This
        problem could maybe be solved with synced scrolling of the three
        textareas instead of display:scroll'ing the outer container.
        Furthermore synced scrolling will keep the horizontal scrollbar
        visible.
*/

class CsvInput extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            lineNumbers: '1',
            errors: undefined,
            linesWithErrors: [],
        }
    }

    componentDidMount() {
        this.onChange()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /* check if text field input was changed externally */
        let prevDefined = typeof prevProps.storedInput !== 'undefined'
        let currDefined = typeof this.props.storedInput !== 'undefined'

        if (prevDefined !== currDefined // "XOR"
            && prevProps.storedInput !== this.props.storedInput) {
            this.validate()
        }

    }

    onChange = (e) => {

        let input = e && e.target && e.target.value ? e.target.value : ''

        let numLines = this.countLines(input)

        this.setState({
            numberOfLines: numLines,
            lineNumbers: [...Array(numLines).keys()].map(v => v + 1).join('\n')
        })

        this.validate()

    }

    validate = debounce(() => {

        let input = this.props.form.getFieldValue(this.props.name)

        if (typeof input === 'undefined') {
            return
        }

        let parsed = parseCoordinates(input, '', this.props.parseTimeIntervals)
        this.props.setDataQuery({ [this.props.name + 'Parsed']: parsed.lines })
        this.setState({
            lineNumbers: parsed.lineNumbers.join('\n'),
            numberOfLines: parsed.numberOfLines,
            errors: parsed.lineStatus.join('\n'),
            linesWithErrors: parsed.linesWithErrors,
            delimiter: parsed.delimiter,
            headerDetected: parsed.headerDetected
        })
        if (parsed.linesWithErrors.length === 0) {
            this.props.setDataQuery({ [this.props.name + 'IsValid']: true })
            this.props.onIsValid()
        } else {
            this.props.setDataQuery({ [this.props.name + 'IsValid']: false })
        }
    }, 300)

    /* Count the number of lines in the CSV. Needed to dynamically adapt the
        height of the CSV input and to print line numbers. The CSV parser also
        gives us these infos, but debounced.
    */
    countLines = (csv) => {
        /* surprisingly String.split() is one of the fastest options across
            all major browsers, but a for loop + indexOf could be faster */
        let numLines = csv.split('\n').length
        return numLines
    }


    render = () => {

        let textFieldsHeight = 
            this.state.numberOfLines > 5 ? this.state.numberOfLines : 5

        return <React.Fragment>

            <div className={s.coordinatsList}>

                {/* Line numbers */}
                <Input.TextArea
                    className={s.lineNumbers}
                    rows={ textFieldsHeight }
                    readOnly
                    value={this.state.lineNumbers}
                />

                {this.props.form.getFieldDecorator(this.props.name, {
                    initialValue: this.props.storedInput,
                    onChange: e => { this.onChange(e) }
                })(
                    <Input.TextArea
                        className={s.coordsListInput}
                        rows={ textFieldsHeight }
                        placeholder={this.props.placeholder}
                    />
                )}

                <Input.TextArea
                    rows={ textFieldsHeight }
                    readOnly
                    className={s.coordsListErrors}
                    value={this.state.errors}
                />

            </div>

            {this.state.linesWithErrors.length > 0 &&
                <p className={s.coordsListErrorMsg}>
                    {this.state.linesWithErrors < 2 ? `Error found. ` : `Errors found. `}
                    {'Click'} <HelpPopovers.CoordinatesList /> {'for help. '}
                    {`Assuming "${this.state.delimiter}" as CSV delimiter. `}
                    {`These lines have errors: `}
                    {this.state.linesWithErrors.length < 10
                        ? this.state.linesWithErrors.join(', ')
                        : this.state.linesWithErrors.slice(0, 9).join(', ')
                            + ' and ' + (this.state.linesWithErrors.length - 9)
                            + ' more.'
                    }
                </p>
            }

            <Tooltip
                title={
                    this.state.headerDetected
                    && this.state.linesWithErrors.length === 0
                        ? 'This action is not compatible with CSV headers.'
                        : ''
                }
                mouseEnterDelay={0.2}
                mouseLeaveDelay={0}
            >
                <Button
                    style={{ marginTop: '0.5em' }}
                    onClick={() => {
                        if (typeof this.props[this.props.name + 'Parsed']
                            === 'undefined')
                        {
                            return
                        }
                        let swapped = this.props.store[this.props.name + 'Parsed']
                        .map((coords) => {
                            let lat = coords[0]
                            coords[0] = coords[1]
                            coords[1] = lat
                            return coords.join(',')
                        }).join('\n')
                        this.props.form.setFieldsValue({
                            [this.props.name]: swapped
                        })
                    }}
                    disabled={
                        this.state.linesWithErrors.length !== 0
                        || this.state.headerDetected
                    }
                >Swap lat/lon</Button>
            </Tooltip>

        </React.Fragment>
    }

}

const mapStateToProps = (state, props) => ({
    storedInput: state.dataQuery[props.name],
})

const mapDispatchToProps = dispatch => {
    return {
        setDataQuery: (dataQuery) => dispatch({
            type: AvailableActions.SET_DATA_QUERY,
            payload: dataQuery
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CsvInput)